import React from 'react';
import Button from 'screens/components/basic/Button';
import TextInput from 'screens/components/basic/TextInput';
import SelectInput from 'screens/components/basic/SelectInput';
import LOOKUP from 'constants/lookup';
import DatePickerInput from 'screens/components/basic/DatePickerInput';
import VisibilityIcon from '@mui/icons-material/Visibility';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import BranchSelectAutoCompleteInput from 'screens/components/basic/BranchSelectAutoCompleteInput';
import CardSimple from 'screens/components/basic/CardSimple';
import BranchMultiSelectAutoCompleteInput from 'screens/components/basic/BranchMultiSelectAutoCompleteInput';

const componentName = "CustomerSales";
const membershipTypes = [
    { text: "All", value: "0" },
    { text: "Employee", value: "3" }
];
const hightideMembershipTypes = [
    { text: "All", value: "0" },
    { text: "Elite Only", value: "1" },
    { text: "Non Elite", value: "2" },
    { text: "Employee", value: "3" }
];
const identificationTypes = [
    { text: "All", value: "0" },
    { text: "Driver's License", value: "1" },
    { text: "Status ID", value: "2" },
    { text: "Passport ", value: "3" }
];
const Header = (props) => {
    const { defaultBranch, branchOptions, isHighTide } = props || {};
                    return (
                    <CardSimple className="p-1">
                        <div className="row row_margin_none">
                            <div className="col-xs-6 col-sm-3 col-md-3 col-lg-2 col-xl-3">
                                <DatePickerInput
                                    name={componentName + LOOKUP.report.common.beginDate.name}
                                    floatingLabelText={LOOKUP.report.common.beginDate.label + "*"}
                                    hintText={LOOKUP.report.common.beginDate.label + "*"}
                                    fullWidth={true}
                                    required
                                />
                            </div> {/* .col */}
                <div className="col-xs-6 col-sm-3 col-md-3 col-lg-2 col-xl-3">
            <DatePickerInput
                name={componentName + LOOKUP.report.common.endDate.name}
                floatingLabelText={LOOKUP.report.common.endDate.label + "*"}
                hintText={LOOKUP.report.common.endDate.label + "*"}
                fullWidth={true}
            />
        </div> {/* .col */}
                <div className="col-xs-6 col-sm-3 col-md-3 col-lg-2 col-xl-3">
            <SelectInput
                defaultValue={"0"}
                name={componentName + "IdentificationType"}
                label={LOOKUP.patient.idType.label}
                floatingLabelText={LOOKUP.patient.idType.label}
                hintText={LOOKUP.patient.idType.hintText}
                options={identificationTypes}
                        fullWidth={true} />
        </div>
        <div className="col-xs-6 col-sm-3 col-md-3 col-lg-2 col-xl-3">
            <TextInput
                defaultValue="222"
                value="222"
                name={componentName + "IdentificationNumber"}
                label={LOOKUP.patient.idNumber.label}
                floatingLabelText={LOOKUP.patient.idNumber.label}
                hintText={LOOKUP.patient.idNumber.hintText}
                fullWidth={true}
                maxLength={50} />
        </div>
        {/* .col */}
        <div className="col-xs-6 col-sm-3 col-md-3 col-lg-2 col-xl-3">
            {
                <SelectInput
                    defaultValue={"0"}
                    name={componentName + "MembershipType"}
                    label={LOOKUP.patient.membershipType.label}
                    floatingLabelText={LOOKUP.patient.membershipType.label}
                    hintText={LOOKUP.patient.membershipType.hintText}
                    options={ isHighTide ? hightideMembershipTypes : membershipTypes }
                    fullWidth={true} />
            }
        </div>
        <div className="col-xs-6 col-sm-6 col-md-5 col-lg-4 col-xl-4">
            <BranchMultiSelectAutoCompleteInput
                defaultValues={defaultBranch}
                name={componentName + LOOKUP.report.common.branchName}
                fullWidth={true}
                autoWidth={true}
                label="Branches"
                floatingLabelText="Branches"
                hintText="Branches"
                style={{ fontFamily: "Open Sans, Arial, Helvetica, sans-serif", fontSize: "16px", letterSpacing: "-0.25px" }}
                options={branchOptions}
                fieldName={'Branches'}
            />
        </div>
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <Button
                type="IconInButton"
                className="pull-right mt-2 ml-1 btnNewBrandPOS"
                name={componentName + LOOKUP.report.common.viewReport.name}
                label={LOOKUP.report.common.viewReport.label}
                        icon={<VisibilityIcon />}
                        onTouchTap={props.showBody}
                    />
                    <Button
                        type="DownloadButton"
                        className="pull-right mt-2 btnNewBrandPOS"
                        name={componentName + LOOKUP.report.common.downloadReport.name}
                        label={LOOKUP.report.common.downloadReport.label}
                onTouchTap={props.download}
            />
        </div>
    </div>
        </CardSimple >
    )
}

export default Header;
